import gemeenteAmsterdam from 'tenants/steunpunt-amsterdam/assets/images/partners/gem-amsterdam-logo.png'
import owa50 from 'tenants/steunpunt-amsterdam/assets/images/partners/owa50-logo.png'
import woonInfo from 'tenants/steunpunt-amsterdam/assets/images/partners/woon-logo.png'
import woonSaem from 'tenants/steunpunt-amsterdam/assets/images/partners/woonsaem-logo.png'
import { Image } from '@app/components/core/image/Image'
import Row from '@app/components/layout/Row'
import useMediaQuery from '@app/util/useMediaQuery'
import { LinkAnchor } from '@app/components/core/link/LinkAnchor'
import { getFullRootDomain, pages } from '@app/util/links'

const partners = [
  {
    imageAlt: 'Gemeente Amsterdam',
    imageSrc: gemeenteAmsterdam,
    href: `${getFullRootDomain(process.env.NODE_ENV)}${pages.municipalityPage('gemeente-amsterdam')}`,
  },
  {
    imageAlt: 'Woon Info',
    imageSrc: woonInfo,
    href: `${getFullRootDomain(process.env.NODE_ENV)}${pages.topicCommunity('steunpunt-amsterdam')}`,
  },
  {
    imageAlt: 'Woon Saem',
    imageSrc: woonSaem,
    href: `${getFullRootDomain(process.env.NODE_ENV)}${pages.serviceProvider('woonsaem')}`,
  },
  {
    imageAlt: 'OWA50',
    imageSrc: owa50,
    href: `${getFullRootDomain(process.env.NODE_ENV)}${pages.serviceProvider('OWA50-plus')}`,
  },
]

export const OurPartners = () => {
  const isMobile = useMediaQuery()
  return (
    <Row
      gap="4rem"
      alignItems="center"
      style={{
        flexWrap: isMobile ? 'wrap' : 'nowrap',
        justifyContent: 'center',
      }}
    >
      {partners.map((partner) => (
        <LinkAnchor
          to={partner.href || '#'}
          key={partner.imageAlt}
          style={{
            flex: isMobile ? '0 0 calc(50% - 2rem)' : 1,
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Image
            src={partner.imageSrc}
            alt={partner.imageAlt}
            resizeHeight={128}
            style={{
              height: '8rem',
              width: 'auto',
              maxWidth: '8rem',
              objectFit: 'contain',
              opacity: 0.7,
            }}
          />
        </LinkAnchor>
      ))}
    </Row>
  )
}
